/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
  EuiHeader,
  EuiHeaderSectionItem,
  EuiLoadingChart,
  EuiText,
} from '@elastic/eui';
import router from 'next/router';
import { FC } from 'react';
import { UserBadge } from './user-badge';
import { CongressBadge } from './congress-badge';

interface HeaderPrimaryProps {
  noAuth?: boolean;
}

export const HeaderPrimary: FC<HeaderPrimaryProps> = props => {
  const { noAuth = false } = props;

  return (
    <EuiHeader
      theme="dark"
      position="fixed"
      className="main-header"
      sections={[
        {
          items: [
            <EuiHeaderSectionItem key="da-logo">
              <img
                onClick={() => router.push('/')}
                style={{ cursor: 'pointer' }}
                src="/images/logo-with-white-text.svg"
                alt="DA Logo"
                width="70px"
              />{' '}
            </EuiHeaderSectionItem>,
            <EuiText
              key="app-title"
              size="m"
              color="white"
              css={{
                marginLeft: '10px',
                paddingLeft: '10px',
                opacity: 0.6,
                borderLeft: '1px solid #ffffff50',
              }}>
              <strong> Delegate Management</strong>
            </EuiText>,
          ],
        },
        {
          items: noAuth
            ? [<EuiLoadingChart key="loading-chart" size="m" mono />]
            : [
                <CongressBadge key="congress-badge" />,
                <UserBadge key="user-badge" />,
              ],
        },
      ]}></EuiHeader>
  );
};
